import { store } from '@core/Store'
import { queryClient } from '@core/Data/ReactQuery'
import { setShouldAllowPendingRacingTicketCountPolling } from '@core/Areas/AppHeader/Store'
import { racingPendingTicketsPollingQuery } from './queries'
import { kambiPendingBetHistoryQuery } from '@core/Areas/KambiSports/Player/helpers/queries'

export function invalidateRacingPendingTicketsQueryData() {
  queryClient.invalidateQueries(racingPendingTicketsPollingQuery)
  store.dispatch(setShouldAllowPendingRacingTicketCountPolling(true))
}

export function invalidateKambiPendingBetHistoryQueryData() {
  queryClient.invalidateQueries(kambiPendingBetHistoryQuery)
}
